import React from 'react';
import './Banner.css'
import Typist from 'react-typist';


const Banner = () => {
    return (
        <div>
            <div className="banner">
                <div class="identity">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-8 offset-md-2 mt-5">
                                <div class="myself justify-content-center">
                                    <img alt="Riyaz Hossain" class="m-auto" src="https://i.postimg.cc/0Qx3dMf6/my-image.png" /><br />
                                    <h1 class="text-center name">Riyaz Hossain</h1>
                                    <Typist className='text-center typist' cursor={{ 'hideWhenDone': true, 'hideWhenDoneDelay': 1 }}>
                                        <span>Engineer | Web Deveolpe</span>
                                        <Typist.Backspace count={6} delay={1000} />
                                        <span>veloper | Programmer</span>
                                    </Typist>
                                    <div class="icon text-center">
                                        <a href="https://web.facebook.com/riyaz.khanshuvo/" target="_blank"><i class="fab fa-facebook"></i></a> <a href="https://www.linkedin.com/in/riyaz-hossain-096b421b4/"><i class="fab fa-linkedin"></i></a> <a href="https://github.com/Riyaz-khan-shuvo" target="_blank"><i class="fab fa-github"></i></a> <a href="https://medium.com/@mdriyaz5965" target="_blank"><i class="fab fa-medium"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Banner;